// extracted by mini-css-extract-plugin
module.exports = {"header":"styles_header__3pFFf","container":"styles_container__2FoxU","title":"styles_title__2cUF5","wrapper":"styles_wrapper__3UJCP","answer":"styles_answer__39n5Y"};